import { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import forgetPassword from "./forgetPassword";
import useAuth from "./hooks/useAuth";
import OtpVerification from "./otpVerification";
import Dashboard from "./pages/dashboard/Dashboard";
import Login from "./pages/Login";
import ResetPassword from "./pages/resetPassword";
import ResetPasswordSuccess from "./pages/resetPasswordSuccess";
import ChangePassword from "./pages/user/changePassword";
import UserProfile from "./pages/user/userProfile";
import { AuthRoute, PrivateRoute } from "./Route";
import authService from "./services/AuthService";
import UserList from "./pages/user/userList";
import NewUser from "./pages/user/addNewUser";
import EditUser from "./pages/user/editUser";
import ServiceList from "./pages/salon_services/list";
import ViewService from "./pages/salon_services/view";
import AddNewServices from "./pages/salon_services/add";
import EditServices from "./pages/salon_services/edit";
import BookingList from "./pages/booking/list";
import AddBooking from "./pages/booking/add";
import ViewBooking from "./pages/booking/view";
import EditBooking from "./pages/booking/edit";
import PaymentHistory from "./pages/billing/paymentHistory";
import Deals from "./pages/salon_services/deal";

import Cards from "./components/cards/Cards";
import EditDealServices from "./pages/salon_services/editDeal";
export default function App() {
  const { authenticatedUser, setAuthenticatedUser } = useAuth();
  const [isLoaded, setIsLoaded] = useState(false);
  const [roleId, setRoleId] = useState(null);
  const authenticate = async () => {
    try {
      const authResponse = await authService.refresh();
      setAuthenticatedUser(authResponse.user);
      const storedUser = localStorage.getItem("user");

      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        const roleId = parsedUser.roleId;
        console.log(roleId);
        setRoleId(roleId);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    if (!authenticatedUser) {
      authenticate();
    } else {
      setIsLoaded(true);
    }
  }, []);

  return isLoaded ? (
    <Router>
      <Switch>
        <AuthRoute exact path="/login" component={Login} />
        <AuthRoute exact path="/forgetPassword" component={forgetPassword} />
        <AuthRoute exact path="/otpVerification" component={OtpVerification} />
        <AuthRoute exact path="/resetPassword" component={ResetPassword} />
        <AuthRoute
          exact
          path="/resetPasswordSuccess"
          component={ResetPasswordSuccess}
        />

        <PrivateRoute exact path="/" component={Dashboard} />
        <PrivateRoute exact path="/changePassword" component={ChangePassword} />

        {/* User Routes */}
        <PrivateRoute exact path="/profile/:id?" component={UserProfile} />
        <PrivateRoute exact path="/users" component={UserList} role={roleId} />
        <PrivateRoute
          exact
          path="/users/add"
          component={NewUser}
          role={roleId}
        />
        <PrivateRoute
          exact
          path="/users/edit/:id"
          component={EditUser}
          role={roleId}
        />

        {/* Booking */}
        <PrivateRoute exact path="/booking" component={BookingList} />
        <PrivateRoute exact path="/payment/add/:id?" component={AddBooking} />
        <PrivateRoute exact path="/booking/existing/" component={AddBooking} />
        <PrivateRoute exact path="/booking/:id" component={ViewBooking} />
        <PrivateRoute exact path="/booking/edit/:id" component={EditBooking} />

        <PrivateRoute
          exact
          path="/services"
          component={ServiceList}
          role={roleId}
        />
        <PrivateRoute
          exact
          path="/services/deals"
          component={Deals}
          role={roleId}
        />
        <PrivateRoute
          exact
          path="/services/:id"
          component={ViewService}
          role={roleId}
        />
        <PrivateRoute
          exact
          path="/deals/edit/:id"
          component={EditDealServices}
          role={roleId}
        />
        <PrivateRoute
          exact
          path="/service/add"
          component={AddNewServices}
          role={roleId}
        />
        <PrivateRoute
          exact
          path="/service/edit/:id"
          component={EditServices}
          role={roleId}
        />
        <PrivateRoute
          exact
          path="/payments"
          component={PaymentHistory}
          role={roleId}
        />

        <PrivateRoute exact path="/card" component={Cards} />
      </Switch>
    </Router>
  ) : null;
}
